<template>
  <span class="material-icons" :class="fontSize" style="vertical-align: text-bottom">
    {{ this.iconName }}
  </span>
</template>

<script>
export default {
  name: 'show-icon',
  props: [
    "name",
    "size"
  ],
  computed: {
    fontSize: function() {
      if (this.size) {
        switch(this.size) {
          case 'xs':
            return 'md-16';
          case 'sm':
            return 'md-18';
          case 'md':
            return 'md-24';
          case 'lg':
            return 'md-36';
          case 'xl':
            return 'md-48';
          default:
            return `md-${this.size}` 
        }
      } else {
        return "md-24"
      }
    },
    iconName: function() {
      switch(this.name) {
        case 'back':
          return 'chevron_left';
        case 'new':
          return 'add';
        case 'show':
          return 'search';
        case 'edit':
          return 'edit';
        case 'delete':
          return 'delete';
        case 'site':
          return 'business';
        case 'notes':
          return 'sticky_note_2';
        case 'location':
          return 'location_on';
        case 'asset':
          return 'widgets';
        case 'meter':
          return 'electric_meter';
        case 'emo':
          return 'energy_savings_leaf';
        case 'image':
          return 'collections';
        case 'issue':
          return 'report_problem'
        default:
          return this.name          
      }
    }

  }
}
</script>
